import { useState } from 'react';
import { UserPlus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ContactList } from '@/components/contacts/ContactList';
import { ContactFormDialog } from '@/components/contacts/ContactFormDialog';
import { ContactImportDialog } from '@/components/contacts/ContactImportDialog';
import type { Contact } from '@/types/api.types';

export function ContactsPage() {
  const [showForm, setShowForm] = useState(false);
  const [editTarget, setEditTarget] = useState<Contact | null>(null);
  const [showImport, setShowImport] = useState(false);

  function handleEdit(contact: Contact) {
    setEditTarget(contact);
    setShowForm(true);
  }

  function handleCloseForm(open: boolean) {
    setShowForm(open);
    if (!open) setEditTarget(null);
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Contatos</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Importe e gerencie seus contatos
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => setShowImport(true)}>
            <Upload className="h-4 w-4" />
            Importar CSV
          </Button>
          <Button onClick={() => setShowForm(true)}>
            <UserPlus className="h-4 w-4" />
            Novo contato
          </Button>
        </div>
      </div>

      <ContactList onEdit={handleEdit} />

      <ContactFormDialog
        open={showForm}
        onOpenChange={handleCloseForm}
        contact={editTarget}
      />

      <ContactImportDialog open={showImport} onOpenChange={setShowImport} />
    </div>
  );
}
